import { Auth } from "aws-amplify";

const config = {
  api: process.env.REACT_APP_BASE_URL,
  options: {
    headers: { "content-type": "application/json" },
  },
};

const headers = (jwtToken: string): any => {
  return {
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };
};

const session = async () =>
  Auth.currentAuthenticatedUser()
    .then((s) => s.signInUserSession.idToken.jwtToken)
    .catch((error) => {
      throw Error(error);
    });

const httpGetPublic = (endpoint: any) => {
  return fetch(`${config.api}${endpoint}`, {
    headers: {
      "content-type": "application/json",
    },
  })
    .then((response) => handleResponse(response))
    .then((response) => response)
    .catch((error) => {
    });
};
const httpGet = (endpoint: any) => {
  return session().then((jwtToken) => {
    return fetch(`${config.api}${endpoint}`, {
      ...headers(jwtToken),
    })
      .then((response) => handleResponse(response))
      .then((response) => response)
      .catch((error) => {
        console.error(error);
        throw Error(error);
      });
  });
};

const httpPost = (endpoint: any, data: any) => {
  return session().then((jwtToken) => {
    return fetch(`${config.api}${endpoint}`, {
      method: "post",
      body: data ? JSON.stringify(data) : null,
      ...headers(jwtToken),
    })
      .then((response) => handleResponse(response))
      .then((response) => response)
      .catch((error) => {
        console.error(error);
        throw Error(error);
      });
  });
};

const httpPostPublic = (endpoint: any, data: any) => {
  return fetch(`${config.api}${endpoint}`, {
    method: "post",
    body: data ? JSON.stringify(data) : null,
    headers: {
      "content-type": "application/json",
    },
  })
    .then((response) => handleResponse(response))
    .then((response) => response)
    .catch((error) => {
      console.error(error);
      throw Error(error);
    });
};

const httpPostFile = (endpoint: any, file: any) => {
  const formData = new FormData();
  formData.append("file", file);
  const url = `${config.api}${endpoint}`;
  return session().then((jwtToken) => {
    const payload = {
      method: "post",
      body: formData,
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    };
    return fetch(url, payload)
      .then((response) => handleResponse(response))
      .then((response) => response)
      .catch((error) => {
        console.error(error);
        throw Error(error);
      });
  });
};
const httpPut = (endpoint: any, data: any) => {
  return session().then((jwtToken) => {
    return fetch(`${config.api}${endpoint}`, {
      method: "put",
      body: data ? JSON.stringify(data) : null,
      ...headers(jwtToken),
    })
      .then((response) => handleResponse(response))
      .then((response) => response)
      .catch((error) => {
        console.error(error);
        throw Error(error);
      });
  });
};
const httpPutExternalFile = (endpoint: any, file: any) => {
  const url = `${endpoint}`;
  const payload = {
    method: "put",
    body: file,
    headers: {
    }
  };

  return fetch(url, payload)
    .then((response) => response)
    .catch((error) => {
      console.error(error);
      throw Error(error);
    });
};
const httpDelete = (endpoint: any, data: any) => {
  return session().then((jwtToken) => {
    return fetch(`${config.api}${endpoint}`, {
      method: "delete",
      body: data ? JSON.stringify(data) : null,
      ...headers(jwtToken),
    })
      .then((response) => handleResponse(response))
      .then((response) => response)
      .catch((error) => {
        console.error(error);
        throw Error(error);
      });
  });
};

const handleResponse = (response: any) => {
  if (response.status === 200 || response.status === 201) {
    return response.json();
  } else if (response.status === 404) {
  } else {
    throw Error(response.json() as string | "error");
  }
};

const ApiFetch = {
  httpGet,
  httpGetPublic,
  httpPost,
  httpPostPublic,
  httpPostFile,
  httpPut,
  httpDelete,
  httpPutExternalFile
};

export default ApiFetch;
